import { ArrowBack, PlayArrow } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';

import { useTranslations } from 'context/TranslationContext';

import { actionButtonsContainerStyle } from 'styles/components/Common';

export interface ApprovalRuleFormHeaderProps {
  isEdit: boolean;
  ruleName?: string;
  isFallback?: boolean;
  onBack: () => void;
  onTestRules: () => void;
  onSave: () => void;
  isSaveDisabled?: boolean;
}

export const ApprovalRuleFormHeader = ({
  isEdit,
  ruleName,
  isFallback = false,
  onBack,
  onTestRules,
  onSave,
  isSaveDisabled = false
}: ApprovalRuleFormHeaderProps) => {
  const { translate } = useTranslations();

  const getHeaderTitle = (): string => {
    if (isFallback) {
      return translate('approvals.fallbackRule');
    }
    if (isEdit) {
      return ruleName || translate('approvals.editRule');
    }
    return translate('approvals.newRule');
  };

  const headerTitle = getHeaderTitle();

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        padding: '0.75rem 1rem',
        backgroundColor: '#F5F5F5',
        borderTopLeftRadius: '1rem',
        borderTopRightRadius: '1rem'
      }}
    >
      <Box display="flex" alignItems="center" gap={0.5}>
        <Button color="primary" startIcon={<ArrowBack />} onClick={onBack}>
          {translate('buttons.back')}
        </Button>
        <Typography variant="body2" sx={{ color: '#d1d5db' }}>
          /
        </Typography>
        <Typography variant="body2" fontWeight={600}>
          {headerTitle}
        </Typography>
      </Box>
      <Box sx={actionButtonsContainerStyle}>
        <Button color="primary" startIcon={<PlayArrow />} onClick={onTestRules}>
          {translate('approvals.testRules')}
        </Button>
        <Button color="primary" onClick={onSave} disabled={isSaveDisabled}>
          {translate('buttons.save')}
        </Button>
      </Box>
    </Box>
  );
};
